import React, {Component} from "react"

import AppContainer from "@irati/ui/src/AppContainer"
import {LangLoader} from "@irati/utils/lang"
import {NestedRoute, PartialRoute, withPartialRoute} from "@irati/utils/history/routing"
import {WELLNESS} from "@irati-web/app/src/routeConfig"
import HasPermissionTo from "@irati/utils/permissions/HasPermissionTo"

import MediaDetail from "../containers/MediaDetail"
import BrowseByCategory from "../containers/BrowseByCategory"
import MediaPaywall from "../containers/MediaPaywall"
import {WellnessSearchPage} from "../containers/WellnessSearchPage"
import {Featured} from "../containers/Featured"
import {WellnessHome} from "../containers/WellnessHome"

interface Props {
  path: string
}

class WellnessRoutes extends Component<Props> {
  render() {
    const {path} = this.props
    return (
      <LangLoader bucket={WELLNESS}>
        <AppContainer>
          <HasPermissionTo permissions={["wellnessHub.enabled"]}>
            <NestedRoute exact path="/wellness" component={WellnessHome} />
            <NestedRoute match={path} path="/categories/:categoryId?" component={BrowseByCategory} />
            <PartialRoute exact match={path} path="/search" component={WellnessSearchPage} title="Wellness Search Results" />
            <PartialRoute exact match={path} path="/details/:mediaId" component={MediaDetail} title="Wellness Hub" />
            <PartialRoute exact match={path} path="/details/:mediaId/pay" component={MediaPaywall} title="Payment" />
            <NestedRoute match={path} path="/featured" component={Featured} />
          </HasPermissionTo>
        </AppContainer>
      </LangLoader>
    )
  }
}

export default withPartialRoute(WellnessRoutes)
